import React from "react";
import { render } from "react-dom";
import { Provider, useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import './App.scoped.css';
import "./App.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./state/store/index";
import $ from "jquery";
// import Utils from './utils/Utils';
import "react-perfect-scrollbar/dist/css/styles.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import metadata from "./metadata.json";

var container = document.createElement("div");
container.id = "accelasearch-bar-container-container";
document.body.insertBefore(container, document.body.firstChild);

console.log(
  "AS v" +
    metadata.buildMajor +
    "." +
    metadata.buildMinor +
    "." +
    metadata.buildRevision
);

window.initLayer = function () {
  var websiteSearchBar = $("#accelasearch-bar-container-container");
  render(
    <Provider store={store}>
      <App />
    </Provider>,
    websiteSearchBar[0]
  );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
